module.exports = __webpack_public_path__ + "static/media/day_ten.cde3ed48.png";